import { useLocation, useNavigate } from 'react-router';

import { useCurrentURL } from './useCurrentURL';

export function useBackNavigation() {
  let navigate = useNavigate();
  let location = useLocation();
  const currentURL = useCurrentURL();

  let handleClick = (e: React.MouseEvent) => {
    let back = location.state?.back;
    if (back) {
      e.preventDefault();
      navigate(back, { state: { prev: currentURL } });
    }
  };
  return handleClick;
}
